export default class AchTestingCtrl {
  constructor(Authentication, AccountService) {
    'ngInject';

    Object.assign(this, { Authentication, AccountService });
  }

  async pushFunds() {
    await this.Authentication.sendRequest({
      method: 'post',
      path: 'account/org/subscription/ach-credit-transfer/pushfunds',
      payload: {
        amount: this.addAmount,
      },
    });

    this.addAmount = 0;
  }
}
